import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import DataManager from '@americanexpress/data-manager';
import SharedScript, { Adobe } from '@americanexpress/shared-scripts';
import {
  AmexDDLRegister,
  getAmexDataManagerConfig,
  useUpdateView,
  getViewInfo,
} from '@americanexpress/data-manager-utils';
import { DDLRegister } from '@americanexpress/react-ddl';
import {
  ExperimentProvider,
  useExperimentationProviderOptions,
} from '@americanexpress/one-xp-client-sdk';
import { getIsNotLoggedIn } from '@/selectors/authSelectors';

const { onTrackCall, ddlProviderProps, reactlyticsProps } =
  getAmexDataManagerConfig();

const PageViewTracker = ({ children, location }) => {
  const updateView = useUpdateView();

  useEffect(() => {
    const viewInfo = getViewInfo();
    updateView({
      ...viewInfo,
    });
  }, [location.pathname, updateView]);

  return children || null;
};

PageViewTracker.propTypes = {
  children: PropTypes.node,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string,
    hash: PropTypes.string,
  }).isRequired,
};

const AnalyticsWrapper = ({ children, location }) => {
  const isNotAuthenticated = useSelector(getIsNotLoggedIn);
  const experimentOptions = useExperimentationProviderOptions();

  return (
    <DataManager
      onTrackCall={onTrackCall}
      ddlProviderProps={ddlProviderProps}
      reactlyticsProps={reactlyticsProps}
    >
      <AmexDDLRegister disableRegisterList={{ view: true }} />
      <PageViewTracker location={location} />
      <DDLRegister name="user.authenticated" value={!isNotAuthenticated} />
      <SharedScript
        name="one-stream-data-handler"
        windowCheck="oneStreamData"
        version="^0.1.2"
      />
      <ExperimentProvider {...experimentOptions}>{children}</ExperimentProvider>
      <Adobe version="^1.2.0" />
    </DataManager>
  );
};

AnalyticsWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
    hash: PropTypes.string,
  }).isRequired,
};

export default AnalyticsWrapper;
